module.exports = __webpack_public_path__ + "img/Tablet - 12.2f5c4315.png";